import { Modal } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniModal = withUnistyles(Modal)

export default UniModal
